import React from 'react';
import { MDBRow, MDBCol, MDBMask, MDBIcon, MDBView } from "mdbreact";
import { Fade } from 'react-reveal';

const Project = (props) => {
  var img = new Image();
  img.src = props.foto;
  return (
    <Fade duration={2000} right>
      <div onClick={() => props.focusNews({ ...props })} style={{
        borderBottom: "1px solid #e0e0e0",
        marginBottom: "1.5rem"
      }}>
        <MDBRow>
          <MDBCol md="3">
            <MDBView hover rounded className="z-depth-1-half mb-4">
              <img
                className="img-fluid mx-auto"
                src={img.src}
                alt=""
                width={(img.width === img.height) ? "50%" : "100%"}
              />
              <a  >
                <MDBMask overlay="white-slight" className="waves-light" />
              </a>
            </MDBView>
          </MDBCol>
          <MDBCol md="9">
            <p className="font-weight-bold dark-grey-text">
              {props.data}
            </p>
            <div className="d-flex justify-content-between">
              <MDBCol size="11" className="text-truncate pl-0 mb-3">
                <a href="#!" className="dark-grey-text">
                  {props.titulli}
                </a>
              </MDBCol>
              <a href="#!">
                <MDBIcon icon="angle-double-right" />
              </a>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </Fade>
  );
};

export default Project;


// WEBPACK FOOTER //
// ./src/components/Project/Project.jsx